module.exports = __webpack_public_path__ + "img/antes_despues_136.638a8d43.png";